import {fetchData} from "@client";

export async function getCompanyApiKeysQuery() {
    const response = await fetchData("/company/apikeys");
    return response.results || [];
}
